import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "./AuthProvider";

export default function ProtectedRoute({ children }) {
  const { status } = useAuth();

  if (status === "loading") {
    return (
      <div className="w-full h-screen grid place-items-center text-sm text-gray-500">
        Checking session…
      </div>
    );
  }
  if (status === "unauthenticated") {
    return <Navigate to="/landlord-signin" replace />;
  }
  return children;
}
